/*
 * @Author: your name
 * @Date: 2020-11-16 15:27:07
 * @LastEditTime: 2020-12-31 16:46:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \bms-pc\src\common\http.js
 */
import store from '../store';
import axios from 'axios';
import { Message, Loading } from 'element-ui';
import router from '../router';
const $https = axios.create()
// $https.defaults.baseURL = 'api';
// 环境的切换
if (process.env.NODE_ENV == 'development') {
	// $https.defaults.baseURL = 'http://172.18.60.189:8199'; //xiaokai
	// $https.defaults.baseURL = 'http://192.168.10.107:8080'; //taotao
	// $https.defaults.baseURL = 'https://172.17.3.68:8080/bms-web'; //生产
	// $https.defaults.baseURL = 'https://bms.qx.com:8080/bms-web'; //生产1
	//$https.defaults.baseURL = 'http://172.17.6.182:8086/bms-web' //测试
	// $https.defaults.baseURL = 'https://172.17.6.182:8085/bms-web' //测试2
	// $https.defaults.baseURL = 'http://172.19.26.132:808/bms-web' //mx
	$https.defaults.baseURL = 'https://testbms.qx.com/bms-web' //测试3
	// $https.defaults.baseURL = 'http://172.19.26.129:808/bms-web' //测试 lyj
	// $https.defaults.baseURL = 'http://localhost:808/bms-web' //测试 mx
	// $https.defaults.baseURL = 'http://192.168.0.193:8081/bms-web' //测试2 bb
	//$https.defaults.baseURL = 'http://192.168.0.90:8081/bms-web' //测试2 zy
  //$https.defaults.baseURL = 'http://192.168.1.14:8081/bms-web' //测试3 zy
	// $https.defaults.baseURL = 'http://172.18.68.177:8080/bms-web' //测试4 zy
	let webUrl = process.env.VUE_APP_WEB_URL;
	if(webUrl){
		$https.defaults.baseURL = webUrl //编程工具设置的环境变量
	}
} else if (process.env.NODE_ENV == 'production') {
	// $https.defaults.baseURL = 'https://172.17.3.68:8080/bms-web'; //生产
	$https.defaults.baseURL = 'https://bms.qx.com:8080/bms-web'; //生产1
	// $https.defaults.baseURL = 'http://172.17.6.180:8080/bms-web' //测试80
	// $https.defaults.baseURL = 'https://172.17.6.182:8085/bms-web' //测试82
	// $https.defaults.baseURL = 'https://172.17.6.90:8085/bms-web' //测试2
}
$https.defaults.timeout = 90000;
// $https.defaults.withCredentials = true; //让ajax携带cookie
$https.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// $https.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
$https.defaults.headers.post['user_login_token'] = '';

//$https.defaults.headers.post['apiVersion']='1.0.0';
//添加一个请求拦截器
let loadingInstance;
$https.interceptors.request.use(
	config => {
        if(!config.isHideLoading){
            loadingInstance = Loading.service({
            	lock: true,
            	text: 'Loading',
            	spinner: 'el-icon-loading',
            	background: 'rgba(0, 0, 0, 0.7)'
            });
        };
		//在请求发出之前进行一些操作
		if (sessionStorage.getItem("TOKEN")) {
			config.headers.user_login_token = sessionStorage.getItem("TOKEN")
		}
		return config;
	},
	err => {
        if(loadingInstance){
            loadingInstance.close();
        };
		Message({ message: '请求超时', type: 'warning' })
		return Promise.reject(err);

	}
);
//添加一个响应拦截器
$https.interceptors.response.use(
	res => {
		if(loadingInstance){
		    loadingInstance.close();
		};
		//在这里对返回的数据进行处理

		if (res.data && res.data.code) {
			if (res.data.code == 900) {
				sessionStorage.clear();
				store.commit('add_tabs', []);
				Message({ message: '登录超时', type: 'warning' })
				//判断防止多次请求路由错误
				if (router.currentRoute.name) {
					router.replace({
						path: '/login',
						// query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
					})
				}
			}
			if (res.data.code != 200 && res.data.message != '暂无数据') {
				Message({ message: res.data.message, type: 'warning' })
			}
		}

		return res.data;
	},
	err => {
		if(loadingInstance){
		    loadingInstance.close();
		};
		Message({ message: '请求失败,请稍后', type: 'warning' });
		return Promise.reject(err);
	}
)

export default $https
